module.exports = __webpack_public_path__ + "static/media/carrot.0c5a6d4a.svg";